/* PetMates: gratis kattenbakschep bij abonnement op Tofu Kattenbakvulling 18L.
   Legt het gratis product (prijs 0,00) in de cart zodra het 18L-abonnement erin zit,
   en haalt het weg als het abonnement verdwijnt. Geen korting nodig.
   Doet niets met knoppen of betalen. */
(function () {
  'use strict';

  var TRIGGER_PRODUCT_ID = 9904750723401;      // Tofu Kattenbakvulling - Voordeelzak 18L
  var GIFT_VARIANT_ID = 55365689377097;       // Gratis kattenbakschep (bij abonnement), prijs 0,00
  var GIFT_PROPERTY = '_gratis_schep';
  var CHECKOUT_PAUSE_MS = 20000;

  var busy = false;
  var pausedUntil = 0;
  var timer = null;

  function log() {
    if (window.console && console.debug) console.debug.apply(console, ['[gratis-schep]'].concat([].slice.call(arguments)));
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function isTrigger(item) {
    return Number(item.product_id) === TRIGGER_PRODUCT_ID && !!item.selling_plan_allocation;
  }

  function isGift(item) {
    return Number(item.variant_id) === GIFT_VARIANT_ID;
  }

  function refresh() {
    if (location.pathname.replace(/\/+$/, '').indexOf('/cart') === 0) {
      location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('gratis-schep:updated'));
    }
  }

  function sync() {
    if (busy || Date.now() < pausedUntil) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasTrigger = cart.items.some(isTrigger);
        var gifts = cart.items.filter(isGift);

        if (hasTrigger && gifts.length === 0) {
          log('abonnement gevonden, gratis schep toevoegen');
          return post('/cart/add.js', {
            items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { '_gratis_schep': 'ja' } }]
          }).then(refresh);
        }

        if (hasTrigger && gifts.length > 0 && (gifts.length > 1 || gifts[0].quantity !== 1)) {
          var fix = {};
          gifts.forEach(function (g, i) { fix[g.key] = i === 0 ? 1 : 0; });
          return post('/cart/update.js', { updates: fix }).then(refresh);
        }

        if (!hasTrigger && gifts.length > 0) {
          log('geen abonnement in de cart, gratis schep verwijderen');
          var updates = {};
          gifts.forEach(function (g) { updates[g.key] = 0; });
          return post('/cart/update.js', { updates: updates }).then(refresh);
        }
      })
      .catch(function (e) { log('fout', e); })
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  // Niet ingrijpen zodra de klant op afrekenen klikt (Firmhouse herschrijft dan de cart).
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('button[name="checkout"], [data-fh-button-type], a[href*="/checkout"]') : null;
    if (el) {
      pausedUntil = Date.now() + CHECKOUT_PAUSE_MS;
      clearTimeout(timer);
    }
  }, true);

  var nativeFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { schedule(); }, function () {});
    }
    return p;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      this.addEventListener('loadend', schedule);
    }
    return nativeOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
